import { types } from "./types";

export const mutations = {
  [types.UPDATE_METAFIELDS_VARIANTS](state, variants) {
    state.variants = [...variants];
  },
  [types.UPDATE_METAFIELDS_PRODUCTS](state, products) {
    state.products = [...products];
  },
  [types.UPDATE_METAFIELDS_GLOBALS](state, globals) {
    state.globals = { ...globals };
  },
};
